import { ApiResponse } from '../models/api-response.model';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class EntityService {
  clone<T>(source: T): T {
    return Object.assign({}, source);
  }

  copy<T>(source: T, target: T): T {
    Object.assign(target, source);
    return target;
  }

  merge = (target: any, ...sources: any[]) => Object.assign(target, ...sources);
  propertiesDiffer = (entityA: {}, entityB: {}) => Object.keys(entityA).find(key => entityA[key] !== entityB[key]);

  extractData<T>(res: ApiResponse): T {
    const payload = res.payload as Response;
    let body = payload && payload.json ? payload.json() : null;
    if (body && body.data) {
      body = body.data;
    }
    const result = <T>(body || {});
    return result;
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/entity.service.ts